import UpcomingMaintenanceEventWidget from '@/pages/Main/Widgets/UpcomingMaintenanceEventWidget'
import css from './upcomingMaintenanceEventsBlock.module.css'
import { IUser } from '@/pages/Users/users.types'
import commonCss from '../../employePageContentBlock.module.css'
import cn from '@/utils/cn'

interface IProps {
  user: IUser
  loading: boolean
}

const UpcomingMaintenanceEventsBlock = (props: IProps) => {
  return (
    <div className={cn(css.wrapper, commonCss.commonBlockSizesWrapper)}>
      <UpcomingMaintenanceEventWidget
        userId={props.user?.id}
        loading={props.loading}
        titleStyle={{ padding: '6px 8px' }}
      />
    </div>
  )
}

export default UpcomingMaintenanceEventsBlock
